// Every flag defaults `false`, per the "ML Frontend Development & Deployment"
// Notion rules: nothing is visible until LaunchDarkly serves it `true` for a
// specific user or segment. LaunchDarkly keys are kebab-cased
// (`mlFrontend-mp-graphs`); the React SDK camel-cases them to match these.
export const FLAGS = {
  // App-level gate. Access also requires the NikolaTeam role check in
  // `AppFeatureGate` and the ML API's hardcoded Cognito allowlist.
  mlFrontendEnabled: false,
} as const satisfies Record<
  string,
  boolean | string | number | { [key: string]: boolean }
>;

/** A page's flag, named from its folder (see `pageFlagKey`); unserved reads as false. */
export type PageFlagKey = `mlFrontend${string}`;

export type Flags = typeof FLAGS;
export type FlagKey = keyof Flags;

type Widen<T> = T extends boolean
  ? boolean
  : T extends string
    ? string
    : T extends number
      ? number
      : { [K in keyof T]: Widen<T[K]> };

export type FlagValues = { [K in FlagKey]: Widen<Flags[K]> } & {
  [K in PageFlagKey]?: boolean;
};
